import * as React from 'react';
import { useRecoilState } from 'recoil';
import { vehicleFocusAtom } from '../../../../OnlineMapNew/OnlineMapState';

interface IBoundsProps {
  googleMap: google.maps.Map | undefined;
  lat?: number;
  lng?: number;
}

function Bounds(props: IBoundsProps) {
  const [vehicleFocus, setVehicleFocus] = useRecoilState<boolean>(vehicleFocusAtom);
  const [initializedBounds, setInitializedBounds] = React.useState<boolean>(false);

  const handleMouseEventListener = React.useCallback(() => {
    setVehicleFocus(false);
  }, [setVehicleFocus]);

  const handleKeyPressListener = React.useCallback(
    (event: KeyboardEvent) => {
      if (event.key === '+' || event.key === '-') {
        setVehicleFocus(false);
      }
    },
    [setVehicleFocus]
  );

  const handleDragEvent = React.useCallback(() => {
    setVehicleFocus(false);
  }, [setVehicleFocus]);

  const handleBoundsEvent = React.useCallback(
    (googleMapBounds: google.maps.Map) => {
      const mapBounds = googleMapBounds.getBounds();
      if (mapBounds && vehicleFocus) {
        googleMapBounds.setCenter(mapBounds.getCenter());
      }
    },
    [vehicleFocus]
  );

  React.useEffect(() => {
    const element = document.getElementById('graph-google-map');
    if (initializedBounds && props.googleMap) {
      google.maps.event.addListenerOnce(props.googleMap, 'dragstart', handleDragEvent);
      google.maps.event.addListenerOnce(props.googleMap, 'bounds_changed', () => {
        if (props.googleMap) {
          handleBoundsEvent(props.googleMap);
        }
      });

      if (element) {
        element.addEventListener('wheel', handleMouseEventListener, { passive: true });
        element.addEventListener('dblclick', handleMouseEventListener);
        element.addEventListener('keydown', handleKeyPressListener);
        element.addEventListener('keypress', handleKeyPressListener);
        element.addEventListener('keyup', handleKeyPressListener);
      }
    }
    setInitializedBounds(true);
    return () => {
      if (initializedBounds && props.googleMap) {
        if (element) {
          element.removeEventListener('wheel', handleMouseEventListener);
          element.removeEventListener('dblclick', handleMouseEventListener);
          element.removeEventListener('keydown', handleKeyPressListener);
          element.removeEventListener('keypress', handleKeyPressListener);
          element.removeEventListener('keyup', handleKeyPressListener);
        }
      }
    };
  }, [
    handleBoundsEvent,
    handleDragEvent,
    handleKeyPressListener,
    handleMouseEventListener,
    initializedBounds,
    props.googleMap,
  ]);

  // Handle bounds
  React.useEffect(() => {
    if (props.googleMap) {
      if (props.lat !== undefined && props.lng !== undefined) {
        const position = new google.maps.LatLng(props.lat, props.lng);
        if (vehicleFocus) {
          props.googleMap.setCenter(position);
          props.googleMap.setZoom(15);
        }
      }
    }
  }, [props.googleMap, props.lat, props.lng, vehicleFocus]);

  React.useEffect(() => {
    if (props.googleMap) {
      if (props.lat !== undefined && props.lng !== undefined) {
        const position = new google.maps.LatLng(props.lat, props.lng);
        props.googleMap.setCenter(position);
        props.googleMap.setZoom(15);
      }
    }
  }, [props.googleMap, props.lat, props.lng]);

  return null;
}

export default Bounds;
